webpackJsonp([35783957827783],{

/***/ 103:
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    getDerivedStateFromProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	    name: true,
	    length: true,
	    prototype: true,
	    caller: true,
	    callee: true,
	    arguments: true,
	    arity: true
	};
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	
	function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	
	        if (objectPrototype) {
	            var inheritedComponent = getPrototypeOf(sourceComponent);
	            if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	            }
	        }
	
	        var keys = getOwnPropertyNames(sourceComponent);
	
	        if (getOwnPropertySymbols) {
	            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            var key = keys[i];
	            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                try { // Avoid failures from read-only properties
	                    defineProperty(targetComponent, key, descriptor);
	                } catch (e) {}
	            }
	        }
	
	        return targetComponent;
	    }
	
	    return targetComponent;
	}
	
	module.exports = hoistNonReactStatics;


/***/ }),

/***/ 125:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var isProduction = ("production") === 'production';
	var prefix = 'Invariant failed';
	function invariant(condition, message) {
	    if (condition) {
	        return;
	    }
	    if (isProduction) {
	        throw new Error(prefix);
	    }
	    var provided = typeof message === 'function' ? message() : message;
	    var value = provided ? "".concat(prefix, ": ").concat(provided) : prefix;
	    throw new Error(value);
	}
	
	module.exports = invariant;


/***/ }),

/***/ 126:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var isProduction = ("production") === 'production';
	function warning(condition, message) {
	  if (!isProduction) {
	    if (condition) {
	      return;
	    }
	
	    var text = "Warning: " + message;
	
	    if (typeof console !== 'undefined') {
	      console.warn(text);
	    }
	
	    try {
	      throw Error(text);
	    } catch (x) {}
	  }
	}
	
	module.exports = warning;


/***/ }),

/***/ 74:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(47);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Firstsection = function (_React$Component) {
	  _inherits(Firstsection, _React$Component);
	
	  function Firstsection() {
	    _classCallCheck(this, Firstsection);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this));
	
	    _this.state = {
	      renderLinks: false
	    };
	    return _this;
	  }
	
	  Firstsection.prototype.componentDidMount = function componentDidMount() {
	    this.setState({
	      renderLinks: true
	    });
	  };
	
	  Firstsection.prototype.render = function render() {
	    var _this2 = this;
	
	    return _react2.default.createElement(
	      "section",
	      {
	        className: "section section--" + this.props.frontmatter.title.toLowerCase()
	      },
	      _react2.default.createElement("div", {
	        className: "section__content",
	        dangerouslySetInnerHTML: { __html: this.props.html }
	      }),
	      this.props.frontmatter.links.map(function (x, i) {
	        return _this2.state.renderLinks ? _react2.default.createElement(
	          "a",
	          { key: i, rel: "noopener noreferrer", target: "_blank", href: x.href },
	          x.text
	        ) : null;
	      }),
	      this.props.page === "cv" && _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: "/projects/" },
	        "Recent"
	      ),
	      this.props.page === "projects" && _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: "/" },
	        "CV"
	      )
	    );
	  };
	
	  return Firstsection;
	}(_react2.default.Component);
	
	exports.default = Firstsection;
	module.exports = exports["default"];

/***/ }),

/***/ 198:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var frontmatter = _ref.frontmatter,
	      html = _ref.html;
	  return _react2.default.createElement(
	    "section",
	    { className: "section section--" + frontmatter.title.toLowerCase() },
	    _react2.default.createElement(
	      "h2",
	      null,
	      frontmatter.title
	    ),
	    _react2.default.createElement("div", {
	      className: "section__content",
	      dangerouslySetInnerHTML: { __html: html }
	    })
	  );
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 199:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var size = 60;
	var length = size * Math.PI;
	var padding = 50;
	var strokeWidth = 30;
	var gap = 2;
	
	exports.default = function (_ref) {
	  var score = _ref.score,
	      name = _ref.name;
	  return _react2.default.createElement(
	    "li",
	    { className: "skill-item" },
	    name,
	    _react2.default.createElement(
	      "div",
	      { className: "skill-item__indicator" },
	      _react2.default.createElement("div", { className: "skill-item__level", style: { width: score + "0%" } })
	    )
	  );
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 200:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Skillitem = __webpack_require__(199);
	
	var _Skillitem2 = _interopRequireDefault(_Skillitem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  return _react2.default.createElement(
	    "section",
	    { className: "section section--skills" },
	    _react2.default.createElement(
	      "h2",
	      null,
	      "Skills"
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "section__content" },
	      _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "h3",
	          null,
	          "Code"
	        ),
	        _react2.default.createElement(
	          "ul",
	          null,
	          _react2.default.createElement(_Skillitem2.default, { score: "8", name: "HTML/CSS" }),
	          _react2.default.createElement(_Skillitem2.default, { score: "9", name: "Javascript" }),
	          _react2.default.createElement(_Skillitem2.default, { score: "7", name: "React JS" }),
	          _react2.default.createElement(_Skillitem2.default, { score: "8", name: "Vue JS / Nuxt JS" }),
	          _react2.default.createElement(_Skillitem2.default, { score: "7", name: "PHP" })
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "h3",
	          null,
	          "Design"
	        ),
	        _react2.default.createElement(
	          "ul",
	          null,
	          _react2.default.createElement(_Skillitem2.default, { score: "9", name: "Blender" }),
	          _react2.default.createElement(_Skillitem2.default, { score: "8", name: "Three JS" }),
	          _react2.default.createElement(_Skillitem2.default, { score: "8", name: "HTML Canvas" })
	        )
	      )
	    )
	  );
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 204:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(47);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Skillsection = __webpack_require__(200);
	
	var _Skillsection2 = _interopRequireDefault(_Skillsection);
	
	var _FirstSection = __webpack_require__(74);
	
	var _FirstSection2 = _interopRequireDefault(_FirstSection);
	
	var _Section = __webpack_require__(198);
	
	var _Section2 = _interopRequireDefault(_Section);
	
	var _fotoAv = __webpack_require__(53);
	
	var _fotoAv2 = _interopRequireDefault(_fotoAv);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IndexPage = function IndexPage(_ref) {
	  var data = _ref.data;
	  return _react2.default.createElement(
	    'article',
	    null,
	    _react2.default.createElement(
	      'header',
	      null,
	      _react2.default.createElement(
	        'h1',
	        null,
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/' },
	          'Alex Jenter'
	        )
	      ),
	      _react2.default.createElement('img', { className: 'portrait', src: _fotoAv2.default, alt: 'portrait of alex jenter' }),
	      data.person.edges.map(function (x) {
	        return _react2.default.createElement(_FirstSection2.default, _extends({ key: x.node.id }, x.node, { page: 'cv' }));
	      })
	    ),
	    _react2.default.createElement(
	      'main',
	      null,
	      data.cv_sections.edges.map(function (x) {
	        return _react2.default.createElement(_Section2.default, _extends({ key: x.node.id }, x.node));
	      }),
	      _react2.default.createElement(_Skillsection2.default, null)
	    )
	  );
	};
	
	var query = exports.query = '** extracted graphql fragment **';
	
	exports.default = IndexPage;

/***/ }),

/***/ 53:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/foto-av.ea963a79.jpg";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-5d2cc04932b713518f4c.js